import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import $ from 'jquery';
import api from "../../api/axiosInstance";
const MyForms = () => {
  debugger;
    const [blocked, setBlocked] = useState(false);
    const [gridKey, setGridKey] = useState(0);
  const [groupedForms, setGroupedForms] = useState({
    "In Progress": [],
    "Not Started": [],
    "Submitted": [],
    "Approved": [],
    "Rejected": []
  });

  useEffect(() => {
    fetchForms();
  }, []);

  const fetchForms = () => {
    debugger;
    const user = JSON.parse(localStorage.getItem("user"));

    const apiUrl = `/MyForms/GetAllForm?CurrentUser=${user.id}`;
    // Now you can use apiUrl with fetch or axios

   api
      .get(apiUrl)
      .then((response) => {
        const forms = response.data;

        // Grouping forms based on statusReasonText
        const grouped = {
          "In Progress": forms.filter((form) => form.statusReasonValue === 121440000),
          "Not Started": forms.filter((form) => form.statusReasonValue === 1),
          "Submitted": forms.filter((form) => form.statusReasonValue === 121440001),
          "Approved": forms.filter((form) => form.statusReasonValue === 121440002),
          "Rejected": forms.filter((form) => form.statusReasonValue === 121440003),
        };

        setGroupedForms(grouped);
        setGridKey(prevKey => prevKey + 1);
      })
      .catch((error) => {
        console.error("Error fetching forms:", error);
      });
  };

  const handleViewForm = (formId, flag) => {
    debugger;
    window.open(`/form-preview/${formId}?flag=${flag}`, '_blank'); // Opens in a new tab
  };


  const handleDelete = (id) => {
    // console.log(`Deleting form with ID: ${id}`);
    debugger;
    $.confirm({
      title: 'Confirm Deletion',
      content: 'Do you really want to delete this?',
      buttons: {
        cancel: {
          text: 'Cancel',
          btnClass: 'btn-red',
          action: function () {
            // Do nothing on cancel
          }
        },
        confirm: {
          text: 'Yes, delete it!',
          btnClass: 'btn-green',
          action: async function () {   
            try {
              debugger;
              setBlocked(true);
              const response = await api.delete(`/MyForms/DeleteMyForm?id=${id}`);
              await fetchForms();
              setBlocked(false);
          debugger;
              // Success alert
              $.alert({
                title: 'Success!',
                content: 'Record deleted successfully.',
                type: 'green',
                buttons: {
                  okay: {
                    text: 'Ok',
                    btnClass: 'btn-green',
                    action: function () {
                    }
                  }
                }
              });
            } catch (error) {
              if (error.response && error.response.status === 409) {
                $.alert({
                  title: 'Error!',
                  content: error.response.data,
                  type: 'red',
                });
              } else {
                $.alert({
                  title: 'Error!',
                  content: 'Error deleting Form',
                  type: 'red',
                });
              }
            }
          }
        }
      }
    });
  };

const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.2)", // light dark shade
  zIndex: 9998,
  cursor: "wait"  // cursor changes to loading
};

const overlayStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#222",
  padding: "30px 50px",
  borderRadius: "12px",
  zIndex: 9999,
  color: "#fff",
  fontSize: "22px",
  textAlign: "center",
  cursor: "wait" // cursor loading
};


  return (
    
    <div>
       {blocked && (
  <>
    {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
    <div style={backdropStyle}></div>

    {/* CENTER BOX */}
    <div style={overlayStyle}>
      <div className="spinner-border" role="status"></div>
      <div>Please wait…</div>
    </div>
  </>
   )}
      {/* In Progress Forms */}
      <>
      <FormGrid
      key={`inprogress-${gridKey}`}
        title="In-Progress Forms"
        forms={groupedForms["In Progress"]}
        showInitiatedOn={true}
        allowDelete={true}
        handleViewForm={handleViewForm} // Passing the function as a prop
        handleDelete={handleDelete}   
      />

      <FormGrid
      key={`notstarted-${gridKey}`}
        title="Not-Started Forms"
        forms={groupedForms["Not Started"]}
        showInitiatedOn={true}
        allowDelete={true}
        handleViewForm={handleViewForm}
        handleDelete={handleDelete} 
      />

      <FormGrid
      key={`submitted-${gridKey}`}
        title="Submitted Forms"
        forms={groupedForms["Submitted"]}
        showSubmittedOn={true}
        allowDelete={false}
        handleViewForm={handleViewForm}
        handleDelete={handleDelete} 
      />

      <FormGrid
      key={`approved-${gridKey}`}
        title="Approved Forms"
        forms={groupedForms["Approved"]}
        showSubmittedOn={true}
        allowDelete={false}
        handleViewForm={handleViewForm}
        handleDelete={handleDelete} 
      />

      <FormGrid
      key={`rejected-${gridKey}`}
        title="Rejected Forms"
        forms={groupedForms["Rejected"]}
        showSubmittedOn={true}
        allowDelete={false}
        handleViewForm={handleViewForm}
        handleDelete={handleDelete} 
      />
      </> 
    </div>
  );
};

// Reusable Grid Component
const FormGrid = ({ title, forms, showInitiatedOn, showSubmittedOn, allowDelete, handleViewForm, handleDelete  }) => {
   const tableId = title.replace(/\s+/g, '') + "Table"; 

 useEffect(() => {
        // Only initialize DataTables if there is data
        if (forms.length === 0) return;
        
        // Initialize DataTables
        const table = window.$(`#${tableId}`).DataTable({
            responsive: true,
            autoWidth: false,
            searching: true,
            ordering: true,
            pageLength: 10,
            lengthChange: false,
            paging: true,
            info: true,
            // destroy: true is optional here, but cleanup is essential
        });

        // 💡 KEY STEP: Cleanup function runs when component unmounts (due to key change)
        return () => {
            // Explicitly destroy the DataTables instance
            if (table) {
                table.destroy();
            }
        };
    }, [forms, tableId]);

      const isValidDate = (date) => {
  if (!date) return false;
  const d = new Date(date);
  if (isNaN(d.getTime())) return false;
  if (d.getFullYear() <= 1) return false; // removes 0001-01-01
  return true;
};

  return (

    <div>
      <div className="card card-success">
        <div className="card-header">
          <h3 className="card-title">{title}</h3>
        </div>
        <div className="card-body">
          <table id={tableId} className="table table-bordered table-striped">
            <thead>
              <tr>
                <th width="49%">Name</th>
                <th width="18%">Form Category</th>
                <th width="18%">Form Sub-Category</th>
                {showInitiatedOn && <th width="10%">Initiated On</th>}
                {showSubmittedOn && <th width="10%">Submitted On</th>}
                <th width="5%">Action</th>
              </tr>
            </thead>
            <tbody>
              {forms.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold", color: "gray" }}>
                    No Forms Available
                  </td>
                </tr>
              ) : (
                forms.map((form) => (
                  <tr key={form.id}>
                    <td>{form.name}</td>
                    <td>{form.formCategoryName}</td>
                    <td>{form.formSubCategoryName}</td>
                    {showInitiatedOn && <td>{!isValidDate(form.submittedOn) ? '' : new Date(form.submittedOn).toLocaleDateString()}</td>}
                    {showSubmittedOn && <td>{new Date(form.submittedOn).toLocaleDateString()}</td>}
                    <td>
                      {/* <Link to={`/editor/FormMastersView/${form.id}`} className="btn btn-xs btn-success" title="View">
                      <i className="fa fa-eye"></i>
                    </Link> */}
                      <button className="btn btn-xs btn-success" title="View"
                        onClick={() => handleViewForm(form.id, 'myForm')}>
                        <i className="fa fa-eye"></i>
                      </button>
                      &nbsp;
                      {allowDelete && (
                        <>
                          <button className="btn btn-xs btn-danger"
                            onClick={() => handleDelete(form.id)}
                            title="Delete">
                            <i className="fa fa-trash"></i>
                          </button>
                          &nbsp;
                        </>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default MyForms;
